import axios from 'axios'

export default function getData (lang) {
  return axios.get(`/data/basic.${lang}.json`, {
    transformResponse: [].concat(
      axios.defaults.transformResponse
      // transformDataHoweverYouWant
    )
  })
  .then(res => res.data)
}



// WEBPACK FOOTER //
// ./client/api/getData.js